export default __webpack_public_path__ + "static/media/spinner.905b52d4.svg";